export const UPLOAD_MAX_FILESIZE = 20 * 1024 * 1024;
